import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 56 56"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#ffdd2d",
      d: "M0 28C0 12.536 12.536 0 28 0s28 12.536 28 28-12.536 28-28 28S0 43.464 0 28Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M16 16h24v12.069a8.662 8.662 0 0 1-4.328 7.501L28.006 40l-7.666-4.43a8.648 8.648 0 0 1-4.328-7.501V16Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#333",
      d: "M22.584 22.35v3.751c.518-.575 1.45-.966 2.51-.966h1.162v4.36c0 1.162-.31 2.175-.783 2.739h5.042c-.472-.564-.783-1.577-.783-2.739v-4.36h1.163c1.07 0 2.003.391 2.51.966v-3.75z"
    }, null, -1)
  ]))]))
}
export default { render: render }